import { render, staticRenderFns } from "./highPlaceWork.vue?vue&type=template&id=b28e9d06&scoped=true"
import script from "./highPlaceWork.vue?vue&type=script&lang=js"
export * from "./highPlaceWork.vue?vue&type=script&lang=js"
import style0 from "./commonTable.css?vue&type=style&index=0&id=b28e9d06&prod&scoped=true&lang=css&external"
import style1 from "./highPlaceWork.vue?vue&type=style&index=1&id=b28e9d06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28e9d06",
  null
  
)

export default component.exports